import { useState } from 'react';
import { Link } from 'react-router-dom';
import WorkCard from '@/components/feature/WorkCard';
import { latestWorks, type MediaType } from '@/mocks/catalog';

const tabs: { key: MediaType | 'all'; label: string }[] = [
  { key: 'all', label: '全部' },
  { key: 'movie', label: '电影' },
  { key: 'tv', label: '剧集' },
  { key: 'show', label: '综艺' },
];

export default function LatestRecommend() {
  const [active, setActive] = useState<MediaType | 'all'>('all');
  const list = active === 'all' ? latestWorks : latestWorks.filter((item) => item.type === active);

  return (
    <section className="w-full bg-background-100/70 px-4 py-12 md:px-8 md:py-16">
      <div className="mx-auto w-full max-w-[1400px]">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="font-label text-xs uppercase tracking-[0.2em] text-accent-600">New Arrivals</p>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">最新影视推荐</h2>
            <p className="mt-2 text-sm text-foreground-500">近期上线的热门作品，按上线时间为你整理</p>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex flex-wrap items-center gap-1 rounded-full border border-background-300/60 bg-background-50 p-1">
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  type="button"
                  onClick={() => setActive(tab.key)}
                  className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-medium transition-colors ${
                    active === tab.key
                      ? 'bg-primary-950 text-background-50'
                      : 'text-foreground-600 hover:text-foreground-950'
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            <Link
              to="/category/movie/list"
              className="hidden items-center gap-1 whitespace-nowrap rounded-md border border-background-300/70 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-700 sm:flex"
            >
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="mt-7 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5 lg:grid-cols-4 xl:grid-cols-5">
          {list.map((work) => (
            <WorkCard key={work.id} work={work} />
          ))}
        </div>
      </div>
    </section>
  );
}